/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './error.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../app/error/error.component';
import * as i3 from '@angular/platform-browser';
import * as i4 from '@ngx-translate/core/src/translate.service';
import * as i5 from '../../../app/common/shared.service';
const styles_ErrorComponent:any[] = [i0.styles];
export const RenderType_ErrorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ErrorComponent,data:{}});
export function View_ErrorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'h1',[['class','errorMessage']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['404'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(null as any));
}
export function View_ErrorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-error',
      ([] as any[]),(null as any),(null as any),(null as any),View_ErrorComponent_0,
      RenderType_ErrorComponent)),i1.ɵdid(1,4308992,(null as any),0,i2.ErrorComponent,
      [i3.Meta,i4.TranslateService,i5.SharedService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const ErrorComponentNgFactory:i1.ComponentFactory<i2.ErrorComponent> = i1.ɵccf('app-error',
    i2.ErrorComponent,View_ErrorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvZXJyb3IvZXJyb3IuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvZXJyb3IvZXJyb3IuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvc2hhaXphci9Qcm9qZWN0cy9NQU1QVS9NeUdvdi9wb3J0YWwtZmUvc3JjL2FwcC9lcnJvci9lcnJvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvZXJyb3IvZXJyb3IuY29tcG9uZW50LnRzLkVycm9yQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNvbnRhaW5lclwiPlxuICA8aDEgY2xhc3M9XCJlcnJvck1lc3NhZ2VcIj40MDQ8L2gxPlxuPC9kaXY+IiwiPGFwcC1lcnJvcj48L2FwcC1lcnJvcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUF1Qiw0Q0FDckI7VUFBQTtVQUFBLDRDQUF5QjtVQUFBLFVBQVE7OztvQkNEbkM7TUFBQTsrQkFBQSxVQUFBO01BQUE7O1FBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/error/error.component.ngfactory.ts